import { AppState } from "..";

function dataRoomView(state: AppState, dataRoomId: string) {
  if (!state.dataRoom[dataRoomId]) {
    return "folder";
  }

  return state.dataRoom[dataRoomId].view;
}

export const dataRoomSelectors = {
  dataRoomView,
};
